import React from "react";
import { Lightbulb } from "lucide-react";

export default function CompletenessMeter({ c, saving, savedAt }) {
  const score = c?.score ?? 0;
  const tone = score >= 80 ? "#1f8a5b" : score >= 55 ? "#165a71" : "#d97757";
  const label = score >= 80 ? "Excellent — pros can price this" : score >= 55 ? "Good — a few details would help" : "Add more detail for better quotes";
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="completeness-meter">
      <div className="flex items-center justify-between">
        <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#252A34]/60">Request quality</div>
        <div className="text-[11px] text-[#252A34]/50" data-testid="autosave-status">{saving ? "Saving…" : savedAt ? "Saved" : ""}</div>
      </div>
      <div className="mt-3 flex items-end gap-2">
        <div className="font-display text-4xl font-semibold tabular-nums" style={{ color: tone }} data-testid="completeness-score">{score}</div>
        <div className="text-sm text-[#252A34]/50 mb-1">/ 100</div>
      </div>
      <div className="mt-2 h-2 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${score}%`, background: tone }} />
      </div>
      <div className="mt-2 text-xs text-[#252A34]/70">{label}</div>
      {(c?.tips || []).length > 0 && (
        <ul className="mt-4 space-y-2">
          {c.tips.slice(0, 3).map((t) => (
            <li key={t} className="flex gap-2 text-xs text-[#252A34]/75"><Lightbulb className="h-3.5 w-3.5 mt-0.5 text-[#d9a441] shrink-0" />{t}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
